
import { css } from 'lit';
export default css`
:host{
  display:block;
  position:relative;
}

.contact-card{
  display:flex;
  align-items:center;
  gap:var(--spacing-4);
}

.content{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-2);
}

.image{
  flex-shrink:0;
  border-radius:var(--spacing-2);
  max-width:var(--spacing-16);
  overflow:hidden;
}

::slotted(pc-link){
  color:green;
}
`;